module.exports = __webpack_public_path__ + "img/active.ed17a885.svg";